import { observer } from 'mobx-react';
import { IUnitValue, IUserDashboardBonusGroup, IUserDashboardPercentGridItem } from 'shared/models';
import { formatValueWithUnits } from './../../../../utilities/formatValueWithUnits';
import { has, keys } from 'mobx';
import { useDashboardDict } from 'pages/profile-dashboard/context/useDashboardDict';

import './styles.scss';
import { ReactNode } from 'react';
import { UiIcon } from 'shared/uikit';
import { ICONS } from 'shared/constants';
import classnames from 'classnames';

type PPDWidgetPercentGridProps = {
    group?: IUserDashboardBonusGroup | null;
    labels?: Record<string, string>;
    isWide?: boolean
};

export const PPDWidgetPercentGrid = observer(({ group, labels = {}, isWide = false }: PPDWidgetPercentGridProps) => {
    if (!group?.percent_grid?.items || !group.percent_grid.items.length) return null;

    const { units } = useDashboardDict();

    const firstRow  = group.percent_grid.items[0];
    const columns = (keys(firstRow) as Array<keyof IUserDashboardPercentGridItem>);

    const renderCell = (value: unknown): ReactNode => {
        if (
            value &&
            typeof value === 'object' &&
            has(value, 'amount') &&
            has(value, 'unit_id')
        ) {
            return formatValueWithUnits(value as IUnitValue, units) ?? '-';
        }

        if (typeof value === 'string' || typeof value === 'number') {
            return value;
        }

        return '-';
    };

    return (
        <div className={classnames("ppd-widget-percent-grid", {
            "ppd-widget-percent-grid--wide": isWide
        })}>
            <table className="ppd-widget-percent-grid__table">
                <thead className="ppd-widget-percent-grid__thead">
                    <tr className="ppd-widget-percent-grid__thead-row">
                        {columns.map((col) => {
                            if (col !== "note") {
                                return (
                                    <th className="ppd-widget-percent-grid__head" key={col}>
                                        {labels[col] ?? col}
                                    </th>
                                )
                            }
                        }
                        )}
                    </tr>
                </thead>
                <tbody className="ppd-widget-percent-grid__body">
                    {group.percent_grid.items.map((row, idx) => (
                        <tr className="ppd-widget-percent-grid__row" key={idx}>
                            {columns.map((col) => {

                                if (col === 'plan_threshold') {
                                    return (
                                        <td className="ppd-widget-percent-grid__cell" key={col}>
                                            <div>{ row[col] }</div>
                                            {row.note && (
                                                <div className="ppd-widget-percent-grid__note">{row.note}</div>
                                            )}
                                        </td>
                                    );
                                }

                                if (col !== "note") {
                                    return (
                                        <td className="ppd-widget-percent-grid__cell" key={col}>
                                            {renderCell(row[col as keyof IUserDashboardPercentGridItem])}
                                        </td>
                                    );
                                }
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
            {group.percent_grid.description && (
                <p className="ppd-widget-percent-grid__description">
                    <UiIcon icon={ICONS.INFO_CIRCLE} size={16} color="#9EA2AA" />
                    {group.percent_grid.description}
                </p>
            )}
        </div>
    );
});
